import {
    FaCheckCircle,
} from "react-icons/fa";

export default function WhyProgramSection() {
    return (
        <section>
            <div className="text-left">
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                    Why We Call It a "Program"
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-8">
                    <span className="block italic text-gray-500 mb-4">
                        (hereinafter referred to as “the Program”) – Offered by Enginuity System
                    </span>
                    The <strong>Backend Engineering Diploma Program</strong> is a comprehensive and
                    structured learning journey designed to equip learners with real-world backend
                    development skills.
                    <br />
                    <br />
                    Unlike a single course, this Program combines multiple modules, hands-on projects,
                    and real-world application scenarios to ensure a deep understanding of core software
                    engineering principles.
                    <br />
                    <br />
                    We use the term <strong>"Program"</strong> instead of just <strong>"Course"</strong> to reflect its broader scope, longer duration, and focus on mastery. The curriculum is carefully curated to provide a complete learning experience—from foundational concepts to advanced backend architecture and deployment.
                </p>

                <div className="grid md:grid-cols-3 gap-6 text-left text-gray-700 mt-10">
                    <div className="flex items-start space-x-3">
                        <FaCheckCircle className="text-green-600 mt-1" />
                        <span>Ideal for aspiring backend developers</span>
                    </div>
                    <div className="flex items-start space-x-3">
                        <FaCheckCircle className="text-green-600 mt-1" />
                        <span>Includes hands-on projects, real-world APIs, and systems design</span>
                    </div>
                    <div className="flex items-start space-x-3">
                        <FaCheckCircle className="text-green-600 mt-1" />
                        <span>Builds career-ready skills for high-growth tech roles</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
